import router from './router'
import NProgress from 'nprogress'
import store from './store'
import { Message } from 'element-ui'
import { getItem } from './utils/cookie'
import { isRelogin } from './utils/request'

// 调整进度条的速度
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

// to：当前位置，from：从哪来
router.beforeEach(async (to, from, next) => {
  // 开启页面进度条
  NProgress.start()
  // 如果本地已经缓存token
  if (getItem('token')) {
    // 修改网站的标题
    window.document.title = to.meta.title || '系统'
    // 如果用户已登录，则不允许进入登录页面
    if (to.path === '/login') {
      // 跳回首页
      next('/home')
    } else if (to.path.startsWith('/education/exam/assessment/review/')) {
      // 复习页不需要加载用户信息和路由
      next()
    } else {
      // 判断用户信息是否存在，如果不存在则获取用户信息
      if (!store.state.user.id) {
        // console.log('获取用户信息: ', count)
        isRelogin.show = true
        store.dispatch('user/getUserInfo').then(() => {
          // 调用生成菜单的方法
          store.dispatch('permission/generateRoutes').then((accessRoutes) => {
            isRelogin.show = false
            accessRoutes.forEach((route) => {
              router.addRoute(route)
            })
            // hack方法 确保路由生成已完成
            next({ ...to, replace: true })
          })
        }).catch(error => {
          store.dispatch('user/logout').then(() => {
            Message.error(error.message)
            // 跳转到登录页面
            next('/login')
          })
        })
      } else {
        next()
      }
    }
  } else {
    // 放行无需登录的页面
    if (to.path === '/login' || to.path.startsWith('/education/exam/assessment/review/')) {
      next()
    } else {
      // 否则在没有登录之前的一切路由都重定向到登录页面
      next('/login')
    }
  }
})

router.afterEach((to, from) => {
  // 关闭进度条
  NProgress.done()
})
